/**
 * Returns the inner dimensions of the chart, which is the total chart's dimensions minus its margins.
 *
 * @param margin The amount of whitespace around the chart
 * @param width The total chart's width
 * @param height The total chart's height
 * @returns Object containing the dimensions of the inner chart canvas area
 */
export default function getChartDimensions(
  margin: {top: number; bottom: number; left: number; right: number},
  width: number,
  height: number
): {chartWidth: number; chartHeight: number} {
  const chartWidth = width > margin.left + margin.right ? width - margin.left - margin.right : width;
  const chartHeight = height > margin.bottom + margin.top ? height - margin.bottom - margin.top : height;
  return {chartWidth, chartHeight};
}
